import React from "react";
import { useLocation } from "react-router-dom";

function useQuery() {
    const { search } = useLocation();
    const queries = React.useMemo(() => new URLSearchParams(search), [search]);

    return queries;
}

export { useQuery }
